/**
 * The Taxonomy screen's API handle. The taxonomy calls — list categories &
 * suggestions, create/update, approve/reject and the auto-review sweep — live on
 * the shared, session-aware data layer in {@link module:api/resources}. This
 * module is a thin hook that hands the screen that `taxonomy` slice, so every
 * call runs through the ONE app client (bearer token + 401-to-/login).
 */
import { useSession } from '../../auth/session';
import type { TaxonomyApi } from '../../api/resources';

export type { TaxonomyApi };

/** The taxonomy API bound to the live session. */
export function useTaxonomyApi(): TaxonomyApi {
  return useSession().api.taxonomy;
}
